enum StepKeys {
    Themes,
    Design,
    Send
}

export default StepKeys;
